import { z } from 'zod';

export const JOB_KINDS = ['composite', 'research', 'prompt-fill', 'image-generate'] as const;
export const JobKindSchema = z.enum(JOB_KINDS);
export type JobKind = z.infer<typeof JobKindSchema>;

export const JOB_STATUSES = [
  'pending',
  'running',
  'succeeded',
  'failed',
  'canceled',
  'interrupted',
] as const;
export const JobStatusSchema = z.enum(JOB_STATUSES);
export type JobStatus = z.infer<typeof JobStatusSchema>;

export function isTerminalJobStatus(s: JobStatus): boolean {
  return s === 'succeeded' || s === 'failed' || s === 'canceled';
}

export function isInFlightJobStatus(s: JobStatus): boolean {
  return s === 'pending' || s === 'running';
}

export const JobUsageSchema = z.object({
  inputTokens: z.number().optional(),
  outputTokens: z.number().optional(),
  predictTimeSec: z.number().optional(),
});
export type JobUsage = z.infer<typeof JobUsageSchema>;

export const CostRangeSchema = z.object({
  low: z.number(),
  expected: z.number(),
  high: z.number(),
});

export const JobSchema = z.object({
  id: z.string(),
  kind: JobKindSchema,
  status: JobStatusSchema,
  parentJobId: z.string().optional(),
  dependsOn: z.array(z.string()),
  brandId: z.string().optional(),
  label: z.string(),
  input: z.unknown(),
  output: z.unknown().optional(),
  replicateId: z.string().optional(),
  usage: JobUsageSchema,
  estimatedCostUsd: CostRangeSchema.optional(),
  actualCostUsd: z.number(),
  error: z.string().optional(),
  createdAt: z.number(),
  startedAt: z.number().optional(),
  completedAt: z.number().optional(),
});
export type Job = z.infer<typeof JobSchema>;

export const JOB_KIND_LABEL: Record<JobKind, string> = {
  composite: 'Pipeline',
  research: 'Brand research',
  'prompt-fill': 'Prompt fill',
  'image-generate': 'Image generation',
};
